// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3cnHr","amount":"Amount_amount__39GVe","tip":"Amount_tip__Mgg1P","tipHeader":"Amount_tipHeader__n6MVX","tipsWrap":"Amount_tipsWrap__1QL7n"};